import zhCN from 'antd/es/locale/zh_CN';
import esES from 'antd/es/locale/es_ES';
import ptBR from 'antd/es/locale/pt_BR';
import idID from 'antd/es/locale/id_ID';
import frFR from 'antd/es/locale/fr_FR';
import itIT from 'antd/es/locale/it_IT';
import nlBE from 'antd/es/locale/nl_BE';
import ruRU from 'antd/es/locale/ru_RU';
import arEG from 'antd/es/locale/ar_EG';

export const locales = {
  'pt-br': ptBR,
  es: esES,
  zh: zhCN,
  fr: frFR,
  it: itIT,
  de: nlBE,
  ru: ruRU,
  id: idID,
  ar: arEG,
};
